import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=5a3520a5&scoped=true&"
import script from "./Follow.vue?vue&type=script&lang=js&"
export * from "./Follow.vue?vue&type=script&lang=js&"
import style0 from "./Follow.vue?vue&type=style&index=0&id=5a3520a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3520a5",
  null
  
)

export default component.exports